import tw from "tailwind-styled-components";

// Orders Skeleton Loading Component
export const OrdersLoading = () => (
  <Container>
    {[...Array(3)].map((_, index) => (
      <Card key={index}>
        <Header>
          <div className="flex items-center space-x-3">
            <Icon />
            <div className="flex-1 flex flex-col gap-1">
              <Title />
              <Date />
            </div>
          </div>
          <Status />
        </Header>
        <Content>
          <div className="flex-1 flex flex-col gap-1">
            <Info />
            <Price />
            <Payment />
          </div>
          <Button />
        </Content>
      </Card>
    ))}
  </Container>
);

// Styled Components
const Container = tw.div`space-y-4 md:px-16 md:py-8 p-5`;
const Card = tw.div`bg-white border border-gray-200 rounded-lg shadow-sm animate-pulse`;
const Header = tw.div`p-4 border-b border-gray-100 flex items-center justify-between`;
const Icon = tw.div`w-12 h-12 bg-gray-200 rounded-lg flex-shrink-0`;
const Title = tw.div`bg-gray-200 h-5 rounded w-32`;
const Date = tw.div`bg-gray-200 h-4 rounded w-24`;
const Status = tw.div`bg-gray-200 h-6 rounded-full w-24`;
const Content = tw.div`p-4 flex items-center justify-between`;
const Info = tw.div`bg-gray-200 h-4 rounded w-3/5`;
const Price = tw.div`bg-gray-200 h-6 rounded w-1/4`;
const Payment = tw.div`bg-gray-200 h-3 rounded w-1/3`;
const Button = tw.div`bg-gray-200 h-10 rounded-lg w-28`;
